import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, finalize, Subject, tap } from 'rxjs';
import { APIRequestResources, CachedAPIRequest, LoadingService } from 'src/app/core';
import { CreateOperatorDTO, GetOperatorDTO, GetUnassignedOperatorsDTO, OperatorPerformanceDashboardDTO, OperatorPerformanceDTO, UpdateOperatorDTO } from '../interface/operator.entity';
import { handleError } from 'src/app/core/utils/utils';

@Injectable({
  providedIn: 'root'
})
export class OperatorService extends CachedAPIRequest{

    constructor(protected override http: HttpClient, private router: Router) {
      super(http, APIRequestResources.OperatorService )
    }

    loading = inject(LoadingService);
    private refreshTrigger = new Subject<void>();
      
    $all = new BehaviorSubject<GetOperatorDTO[]>([]);
    all = toSignal(this.$all, {initialValue: []});

    $active = new BehaviorSubject<any | undefined>(undefined);
    active = toSignal(this.$active, {initialValue: undefined});

    getAll(departmentId: number | null = null, refresh = true) {
      return this.get<GetOperatorDTO>({
          params: departmentId ? { department: departmentId } : {}
        },
        refresh ? 'freshness' : 'performance'
      ).pipe(
        tap(res => this.$all.next([{ operators: res.data.operators }])),
        catchError(handleError)
      );
    }

    create = (operator: CreateOperatorDTO) => {
      const payload = {
        operators: [operator]
      }
      return this.post<any>(payload, {}).pipe(
      );
    }

    update = (id: number, updateShiftDTO: UpdateOperatorDTO) => {
        const options = {suffix: `/${id}`}
        return this.put<any>(updateShiftDTO, options).pipe(
        )
    }

    getUnassignedOperators = (operatorIds: number[]) => {
      const payload = { operatorIds };
      return this.post<GetUnassignedOperatorsDTO>(payload, {endpoint: 'unassigned'}).pipe(
        tap(res => {
          this.$all.next([{ operators: res.data.operators }]);
        }),
        catchError(handleError)
      );
    }

    performance = (searchParams: any, refresh = true) => {
      return this.get<OperatorPerformanceDashboardDTO>({
        endpoint: `performance/dashboard`,
        params: searchParams,
      }, refresh ? 'freshness' : 'performance');
    };

    getNcr = (searchParams: {
      employeeNo: string;
      startDate: string;
      endDate: string;
      ncrNumber?: string;
      job?: string | number;
      assignedMachineId?: string | number;
      status?: string;
      ncrType?: string;
      productTypeId?: string | number;
      itemsPerPage?: number;
      pageNumber?: number;
    }, refresh = true) => {
      return this.get<any>({
        endpoint: 'ncr',
        params: searchParams,
      }, refresh ? 'freshness' : 'performance');
    };



}
